import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { AreaResponse } from '@doda/api-client/aspida/@types';
import { appAxios } from '../../libs/axios/appAxios';

export const getArea = async (headers?: IncomingHttpHeaders) => {
  return appAxios({
    url: '/api/v1/area',
    headers,
  }).then((res: AxiosResponse<AreaResponse[]>) => {
    return res.data;
  });
};
